import useDemoHelper from "./useDemoHelper";
import step91 from "../../../../../assets/demo/emergency/9.1.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashInputBeneficiaryReservation = () => {
        demoHelper.flash('[data-test="input-beneficiary-reservation"]', 2);
    }

    const flashInputArrivedAt = () => {
        demoHelper.flash('[data-test="input-arrived-at"]', 2);
    }

    const flashInputLeftAt = () => {
        demoHelper.flash('[data-test="input-left-at"]', 2);
    }

    const flashInputNextOrderComment = () => {
        const element = document.querySelector('[data-test="skeleton-body"]');
        element.scrollTop = element.scrollHeight;

        demoHelper.flash('[data-test="input-next-order-comment"]', 2);
    }

    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 27 seconds
            window.sound.src = step91;
            window.sound.play();

            await demoHelper.sleep(7000);

            flashInputBeneficiaryReservation();

            await demoHelper.sleep(3000);

            flashInputArrivedAt();

            flashInputLeftAt();

            await demoHelper.sleep(12000);

            flashInputNextOrderComment();

            await demoHelper.sleep(3000);

            demoHelper.unlockInteract();
        }
    }
}